import { FC, PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import { SharedLink } from '../link/SharedLink';
import { FontIcons } from '../icons/FontIcons';

import { GhostLinkProps } from './constants';
import { getGhostLinkStyle } from './utils';

export const GhostLink: FC<PropsWithChildren<GhostLinkProps>> = ({
  href,
  icon = 'arrowRight',
  fullSizeOverlay,
  children,
  target,
  className,
  iconClassName,
  iconPosition = icon === 'arrowLeft' ? 'left' : 'right',
  theme = 'default',
  animate = true,
}) => {
  if (!href || !children) return null;
  return (
    <SharedLink
      href={href}
      className={getGhostLinkStyle({
        className,
        iconPosition,
      })}
      data-theme={theme}
      underlineSize={0}
      target={target}
      underline='off'
      fullSizeOverlay={fullSizeOverlay}
    >
      {children}
      <FontIcons
        icon={icon}
        className={clsx(iconClassName, {
          'group-hover/button:translate-x-2 transition-transform':
            iconPosition === 'right' && animate,
        })}
      />
    </SharedLink>
  );
};
